import { EventType } from '@/analytics/types';
import type { LandingPageProfile } from '@/app/components/LandingPage/LandingPageProfileCards/LandingPageProfileCard';

const goToMedicalAdvisor = (path: string) => {
  void window.ouraAnalytics.track(EventType.CTAClicked, {
    cta: 'read_more',
    location: 'science and research',
    action: 'goes to blog',
    path,
  });

  window.open(path, '_blank');
};

export const medicalAdvisors: LandingPageProfile[] = [
  {
    description: 'science_and_research_rebecca_robbins',
    name: 'Dr. Rebecca Robbins, Phd',
    image: 'blue-sky/science-and-research/rebecca-robbins',
    imageMobile: 'blue-sky/science-and-research/rebecca-robbins-mobile',
    imageAlt: 'science_and_research_medical_advisor_female_alt',
    onLinkClick: () => goToMedicalAdvisor('/blog/oura-qa-rebecca-robbins-phd/'),
  },
  {
    description: 'science_and_research_matthew_walker',
    name: 'Dr. Matthew Walker, Phd',
    image: 'blue-sky/science-and-research/matthew-walker',
    imageMobile: 'blue-sky/science-and-research/matthew-walker-mobile',
    imageAlt: 'science_and_research_medical_advisor_male_alt',
    onLinkClick: () => goToMedicalAdvisor('/blog/oura-qa-matthew-walker-phd/'),
  },
  {
    description: 'science_and_research_jake_deutsch',
    name: 'Dr. Jake Deutsch, MD',
    image: 'blue-sky/science-and-research/jake-deutsch',
    imageMobile: 'blue-sky/science-and-research/jake-deutsch-mobile',
    imageAlt: 'science_and_research_medical_advisor_male_alt',
    onLinkClick: () => goToMedicalAdvisor('/blog/the-oura-qa-jake-deutsch/'),
  },
  {
    description: 'science_and_research_elissa_epel',
    name: 'Dr. Elissa Epel, Phd',
    image: 'blue-sky/science-and-research/elissa-epel',
    imageMobile: 'blue-sky/science-and-research/elissa-epel-mobile',
    imageAlt: 'science_and_research_medical_advisor_female_alt',
    onLinkClick: () => goToMedicalAdvisor('/blog/the-oura-qa-elissa-epel-phd/'),
  },
  {
    description: 'science_and_research_eleni_jaswa',
    name: 'Dr. Eleni Jaswa, MD, MSc, FACOG',
    image: 'blue-sky/science-and-research/eleni-jaswa',
    imageMobile: 'blue-sky/science-and-research/eleni-jaswa-mobile',
    imageAlt: 'science_and_research_medical_advisor_female_alt',
    onLinkClick: () => goToMedicalAdvisor('/blog/oura-qa-dr-eleni-jaswa/'),
  },
  {
    description: 'science_and_research_sara_gottfried',
    name: 'Sara Gottfried, MD',
    image: 'blue-sky/science-and-research/sara-gottfried',
    imageMobile: 'blue-sky/science-and-research/sara-gottfried-mobile',
    imageAlt: 'science_and_research_medical_advisor_female_alt',
    onLinkClick: () =>
      goToMedicalAdvisor('/blog/oura-qa-dr-sara-gottfried-md/'),
  },
  {
    description: 'science_and_research_jagmeet_singh',
    name: 'Jagmeet P. Singh MD ScM DPhil',
    image: 'blue-sky/science-and-research/jagmeet-singh',
    imageMobile: 'blue-sky/science-and-research/jagmeet-singh-mobile',
    imageAlt: 'science_and_research_medical_advisor_male_alt',
  },
  {
    description: 'science_and_research_michael_chee',
    name: 'Michael WL Chee, MBBS, FRCP (Edin)',
    image: 'blue-sky/science-and-research/michael-chee',
    imageMobile: 'blue-sky/science-and-research/michael-chee-mobile',
    imageAlt: 'science_and_research_medical_advisor_male_alt',
    onLinkClick: () => goToMedicalAdvisor('/blog/oura-qa-dr-michael-wl-chee/'),
  },
];
